import React from 'react';
import './Hero.scss';

const Hero = () => (
  <section className="hero">
    <div className="hero-content">
      <h1>We Do Specialize in Biofuels</h1>
      <p>Organixine is a modern, eco-friendly solution for sustainable energy. Discover our innovative biofuel projects and join the green revolution.</p>
      <a href="#solutions" className="hero-btn">Learn More</a>
    </div>
  </section>
);

export default Hero;